import React from 'react';
import { observer } from 'mobx-react-lite';
import { IMInputText, IMRadioGroup, IMSelect } from '@insurancemenu/imenu-components-lib';
import SectionTitle from 'components/common/general/SectionTitle';
import DomainProductLines from 'components/common/initiate-proposal/DomainProductLines';
import {
  IMFormStyled,
  FollowingSectionTitleStyled,
  IMZipCodeFieldStyled,
  IMZipCountyFieldStyled,
  IMZipStateFieldStyled,
} from 'components/common/initiate-proposal/styles';
import { useNEDDQuoteProposalInfoPageStore } from 'store/pages/quote/quote-proposal-info/nedd/pageStore';
import { DEFAULT_PROPOSAL_INFO_FORM_ID } from './constants';

const NEDDQuoteProposalInfoForm: React.FC = observer(() => {
  const {
    proposalFormDelegate: { proposalForm, effectiveDatesOptions },
    proposalInfoDelegate: { domainProductLineItems, isDomainProductLinesLoading },
    isStepCompleted,
  } = useNEDDQuoteProposalInfoPageStore();

  return (
    <IMFormStyled id={DEFAULT_PROPOSAL_INFO_FORM_ID} formController={proposalForm}>
      <SectionTitle title="Basic Information" />
      <IMInputText label="Proposal Name" name="proposalName" size="full" />
      <IMSelect label="Effective Date" name="effectiveDate" size="full" options={effectiveDatesOptions} disabled />
      <IMZipCodeFieldStyled size="s" disabled={isStepCompleted} />
      <IMZipStateFieldStyled size="s" disabled />
      <IMZipCountyFieldStyled size="s" disabled={isStepCompleted} />
      <FollowingSectionTitleStyled title="Additional Information" />
      <IMRadioGroup
        label="Is the group you are enrolling a New Hampshire public sector group (i.e. town, city, county, school,
              quasi-municipal)?"
        name="nhPublicSector"
        radioButtons={[
          { label: 'Yes', value: 'Yes', disabled: true },
          { label: 'No', value: 'No', disabled: true },
        ]}
      />
      <FollowingSectionTitleStyled title="Available Product Lines" />
      <DomainProductLines domainProductLineItems={domainProductLineItems} isLoading={isDomainProductLinesLoading} />
    </IMFormStyled>
  );
});

export default NEDDQuoteProposalInfoForm;
